import React from "react";

function NotServiceable() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512.01 512.01"
    >
      <path
        fill="#6b4878"
        d="M488.365 293.91a233.286 233.286 0 01-12.16 45.46l17.5 16.92-32 55.43-23.45-6.71a236.87 236.87 0 01-33.25 33.24l6.71 23.46-55.42 32-16.93-17.5c-14.52 5.5-29.73 9.6-45.46 12.15l-5.91 23.65h-64l-5.91-23.65a233.59 233.59 0 01-45.44-12.15l-16.93 17.5-55.42-32 6.71-23.46a236.87 236.87 0 01-33.25-33.24l-23.46 6.71-32-55.43 17.5-16.92c-5.5-14.52-9.61-29.73-12.15-45.46L.005 288v-64l23.64-5.91c2.55-15.73 6.65-30.94 12.15-45.46l-17.5-16.92 32-55.42 23.45 6.71c9.95-12.16 21.1-23.3 33.25-33.25l-6.7-23.45 55.42-32 16.91 17.49c14.53-5.5 29.73-9.6 45.46-12.15L223.995 0h64l5.91 23.64c15.74 2.54 30.95 6.65 45.47 12.15l16.92-17.49 55.42 32-6.7 23.45a236.87 236.87 0 0133.24 33.25l23.45-6.71 32 55.42-17.49 16.92c5.5 14.52 9.6 29.73 12.15 45.45l23.64 5.92v64z"
        data-original="#6b4878"
      ></path>
      <path
        fill="#412c49"
        d="M488.365 293.91a233.286 233.286 0 01-12.16 45.46l17.5 16.92-32 55.43-23.45-6.71a236.87 236.87 0 01-33.25 33.24l6.71 23.46-55.42 32-16.93-17.5c-14.52 5.5-29.73 9.6-45.46 12.15l-5.91 23.65h-31.99V0h31.99l5.91 23.64c15.74 2.54 30.95 6.65 45.47 12.15l16.92-17.49 55.42 32-6.7 23.45a236.87 236.87 0 0133.24 33.25l23.45-6.71 32 55.42-17.49 16.92c5.5 14.52 9.6 29.73 12.15 45.45l23.64 5.92v64z"
        data-original="#412c49"
      ></path>
      <path
        fill="#f9f1f1"
        d="M384.005 256c0 97.89-128 177.24-128 177.24-97.89 0-177.25-79.35-177.25-177.24s79.36-177.25 177.25-177.25c0 0 128 79.36 128 177.25z"
        data-original="#f9f1f1"
      ></path>
      <path
        fill="#e2dff5"
        d="M433.245 256c0 97.89-79.35 177.24-177.24 177.24V78.75c97.89 0 177.24 79.36 177.24 177.25z"
        data-original="#e2dff5"
      ></path>
      <path
        fill="#ff3d58"
        d="M301.265 256l45.25 45.26-45.25 45.25-45.26-45.25-45.26 45.25-45.25-45.25 45.25-45.26-45.25-45.26 45.25-45.25 45.26 45.25 45.26-45.25 45.25 45.25z"
        data-original="#ff3d58"
      ></path>
      <path
        fill="#e50057"
        d="M301.265 256l45.25 45.26-45.25 45.25-45.26-45.25v-90.52l45.26-45.25 45.25 45.25z"
        data-original="#e50057"
      ></path>
    </svg>
  );
}

export default NotServiceable;